import React, { cloneElement } from 'react';
import { NavLink } from 'react-router-dom';
import { XIcon, LogOutIcon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
interface NavigationItem {
  to: string;
  label: string;
  icon: JSX.Element;
  roles: string[];
}
interface MobileNavProps {
  isOpen: boolean;
  toggleMenu: () => void;
  navigationItems: NavigationItem[];
}
const MobileNav = ({
  isOpen,
  toggleMenu,
  navigationItems
}: MobileNavProps) => {
  const {
    user,
    logout
  } = useAuth();
  if (!isOpen) {
    return <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-neutral-100 z-10" data-id="element-102">
        <div className="flex items-center justify-around" data-id="element-103">
          {navigationItems.map(item => <NavLink key={item.to} to={item.to} className={({
          isActive
        }) => `flex flex-col items-center py-3 px-4 ${isActive ? 'text-primary' : 'text-neutral-400'}`} data-id="element-104">
              {cloneElement(item.icon, {
            className: 'w-6 h-6'
          })}
              <span className="text-xs mt-1" data-id="element-105">{item.label}</span>
            </NavLink>)}
        </div>
      </nav>;
  }
  return <div className="md:hidden fixed inset-0 bg-neutral-900 bg-opacity-50 z-50 flex" data-id="element-106">
      <div className="bg-white w-4/5 max-w-sm h-full overflow-y-auto" data-id="element-107">
        <div className="p-4 flex justify-between items-center border-b border-neutral-100" data-id="element-108">
          <h2 className="text-lg font-bold" data-id="element-109">CMS Finance</h2>
          <button onClick={toggleMenu} className="p-2 rounded-full hover:bg-neutral-50" aria-label="Close menu" data-id="element-110">
            <XIcon className="w-6 h-6 text-neutral-500" data-id="element-111" />
          </button>
        </div>
        {user && <div className="p-4 border-b border-neutral-100" data-id="element-112">
            <div className="flex items-center" data-id="element-113">
              <div className="w-12 h-12 rounded-full bg-secondary flex items-center justify-center mr-3" data-id="element-114">
                <span className="text-white font-bold text-lg" data-id="element-115">
                  {user.name.charAt(0)}
                </span>
              </div>
              <div data-id="element-116">
                <div className="font-medium" data-id="element-117">{user.name}</div>
                <div className="text-sm text-neutral-400" data-id="element-118">
                  {user.organization}
                </div>
              </div>
            </div>
          </div>}
        <nav className="p-4 space-y-2" data-id="element-119">
          {navigationItems.map(item => <NavLink key={item.to} to={item.to} className={({
          isActive
        }) => `flex items-center p-3 rounded-lg ${isActive ? 'bg-neutral-50 text-primary font-medium' : 'text-neutral-400'}`} onClick={toggleMenu} data-id="element-120">
              {item.icon}
              <span data-id="element-121">{item.label}</span>
            </NavLink>)}
          {user && <button onClick={() => {
          toggleMenu();
          logout();
        }} className="flex items-center p-3 rounded-lg text-neutral-400 w-full text-left" data-id="element-122">
              <LogOutIcon className="w-5 h-5 mr-3" data-id="element-123" />
              <span data-id="element-124">Sign Out</span>
            </button>}
        </nav>
      </div>
    </div>;
};
export default MobileNav;